import {type AuthState} from "@src/features/auth/auth-models";


const AUTH_STATE_KEY = "authState";


function saveAuthState(authState: AuthState): void {
	const serializedData = JSON.stringify(authState);
	localStorage.setItem(AUTH_STATE_KEY, serializedData);
}


function loadAuthState(): AuthState | null {
	const storedData = localStorage.getItem(AUTH_STATE_KEY);
	if (storedData) {
		const authState: AuthState = JSON.parse(storedData) as AuthState;
		return authState;
	}
	return null;
}


function clearAuthState(): void {
	localStorage.removeItem(AUTH_STATE_KEY);
}


export const authStorage = {
	saveAuthState, loadAuthState, clearAuthState
} as const;
